import React from 'react';
import { DragOverlay, defaultDropAnimationSideEffects } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import { Portal } from '../Portal/index.js';
const dropAnimationConfig = {
    sideEffects: defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0.4',
            },
        },
    }),
};
export const SortableOverlay = ({ children, }) => {
    return (React.createElement(Portal, null,
        React.createElement(DragOverlay, { wrapperElement: "ul", modifiers: [restrictToWindowEdges], dropAnimation: dropAnimationConfig }, children)));
};
//# sourceMappingURL=SortableOverlay.js.map